import React, { useState, useEffect } from 'react';
import BackIcon from '../common/Back/BackIcon';
import PageHeading from '../common/Heading/PageHeading';
import { ContentTitle } from '../ui/styled';
import TabPanel, { a11yProps } from '../common/Tabs/TabPanel';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Referral from './EpisodeForms/Referral';
import TP1502 from './EpisodeForms/TP1502';
import ProfA1 from './EpisodeForms/ProfA1';
import ProfB1 from './EpisodeForms/ProfB1';
import ProfB2 from './EpisodeForms/ProfB2';
import ProfA2 from './EpisodeForms/ProfA2';
import Activities from './EpisodeForms/ActivitiesTab/Activities';
import QualityAssurance from './EpisodeForms/QualityAssuranceTab/QualityAssurance';
import AorCm from './EpisodeForms/AORCMTab/aorCm';
import StsAlert from './EpisodeForms/stsAlert/stsAlert';
import EpisodeParticipant from './EpisodeParticipant/EpisodeParticipant';
import AuthTab from './EpisodeForms/AuthTab/AuthTab';
import TwoTwoEightFour from './EpisodeForms/2284Tab/2284';
import Transport from './EpisodeForms/TransportTab/Transport';
import Cmp from './EpisodeForms/CmpTab/Cmp';
import Oras from './EpisodeForms/Oras/Oras';
import EpisodeAuditPanel from './EpisodeAuditPanel';
import { Auth } from 'aws-amplify';
import { useDispatch, useSelector } from 'react-redux';
import { dateFormat,
         PARTICIPANTS_EPISODE_DETAIL_URL,
        } from '../../constants';
import { getStopApi } from '../../services/StopApi/StopApi';
import moment from 'moment';

const EpisodeDetail = () => {

  const [user, setUser] = useState(null);
  const [episodeParticipant, setEpisodeParticipant] = useState({
    isLoading: false,
    data: [{}],
    pageSize: 100,
    total: 0,
    page: 1,
  });
  const [episodeAuditData, setEpisodeAuditData] = useState(null);

  const episodeId = useSelector(
    (state) => state?.episodeDetail?.singleEpisode[0]?.episodeId
  );

  const participantInfo = useSelector(
    (state) => state?.participants?.participantsDetail
  );

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken && participantInfo) {
      fetchEpisodeParticipantData();
    }
    getUser().then((userData) => setUser(userData));
  }, [user?.signInUserSession.accessToken.jwtToken, participantInfo]);

  const fetchEpisodeParticipantData = async () => {
    //console.log('### FETCH EPISODE PARTICIPANT DATA WITH:');
    //console.log(episodeId);
    //console.log('### participantInfo');
    //console.log(participantInfo);
    setEpisodeParticipant((prveState) => ({ ...prveState, isLoading: true }));
    const commonParams = `${PARTICIPANTS_EPISODE_DETAIL_URL}${participantInfo[0].id}/episodes?PageNumber=${episodeParticipant.page}&PageSize=${episodeParticipant.pageSize}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    getStopApi({ commonParams, authorization }).then((response) => {
      const json = response.data;
      const jsonData = json?.filter((item) =>
        item.episodeID === episodeId ? item.episodeID : ''
      );
      //console.log('### fetchEpisodeParticipantData');
      //console.log(jsonData[0]);

      // Store audit data for the panel
      setEpisodeAuditData({
        episodeCreatedby: jsonData[0]?.episodeCreatedby,
        episodedDateCreate: jsonData[0]?.episodedDateCreate,
        episodeEditedby: jsonData[0]?.episodeEditedby,
        episodedDateEdit: jsonData[0]?.episodedDateEdit
      });

      setEpisodeParticipant((prveState) => ({
        ...prveState,
        isLoading: false,
        data: [
          {
            _id: 0,
            key: participantInfo[0].key,
            id: participantInfo[0].id,
            dateOfBirth: participantInfo[0].dateOfBirth ? moment(participantInfo[0].dateOfBirth).format(
              dateFormat
            ): '-',
            gender: participantInfo[0].gender?.value || participantInfo[0].gender,
            registration290: participantInfo[0].registration290,
            arsonist: participantInfo[0]?.arsonist,
            cCCMS: jsonData[0]?.cCCMS,
            cDCNumber: jsonData[0]?.cDCNumber,
            expectedEPRD: jsonData[0]?.expectedEPRD
              ? moment(jsonData[0]?.expectedEPRD)
                  .format(dateFormat)
                  .split('T')[0]
              : '-',
            reg: jsonData[0]?.reg,
            paroleCounty:
              jsonData[0]?.paroleCounty === null
                ? '-'
                : jsonData[0]?.paroleCounty.value,
            episodeSAPStartDate: jsonData[0]?.episodeSAPStartDate
              ? moment(jsonData[0]?.episodeSAPStartDate)
                  .format(dateFormat)
                  .split('T')[0]
              : '-',
            episodeDischargeDate: jsonData[0]?.episodeDischargeDate
              ? moment(jsonData[0]?.episodeDischargeDate)
                  .format(dateFormat)
                  .split('T')[0]
              : '-',
            referralSource: jsonData[0]?.referralSource.value,
            caseManager: jsonData[0]?.caseManager,
          },
        ],
      }));
    }).catch((e) => alert(e));
  };


  const [value, setValue] = useState(5);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <Box sx={{ width: '100%' }}>
        <Box
          style={{
            backgroundColor: '#fafafb',
            position: 'sticky',
            top: '64px',
            zIndex: 2,
          }}
        >
          <ContentTitle container>
            <BackIcon level={-1} />
            <PageHeading title='Episode Detail' />
          </ContentTitle>
          <EpisodeParticipant />
          <Box 
            sx={{
              borderBottom: 2,
              borderColor: '#747070',
              padding: '15px 0px 5px 0px',
            }}
          >
            <Tabs
              value={value}
              onChange={handleTabChange}
              aria-label='episode tabs'
            >
              <Tab label='Referral' {...a11yProps(0)} />
              <Tab label='Prof A1' {...a11yProps(1)} />
              <Tab label='Prof A2' {...a11yProps(2)} />
              <Tab label='Prof B1' {...a11yProps(3)} />
              <Tab label='Prof B2' {...a11yProps(4)} />
              <Tab label='Auth' {...a11yProps(5)} />
              <Tab label='Activities' {...a11yProps(6)} />
              <Tab label='Quality Assurance' {...a11yProps(7)} />
              <Tab label='AOR/CM' {...a11yProps(8)} />
              <Tab label='Sts Alert' {...a11yProps(9)} />
              <Tab label='2284' {...a11yProps(10)} />
              <Tab label='Transport' {...a11yProps(11)} />
              <Tab label='CMP' {...a11yProps(12)} />
              <Tab label='ORAS' {...a11yProps(13)} />
              {/*<Tab label='Treatment Plan/1502' />*/}
            </Tabs>
          </Box>
        </Box>
        <TabPanel value={value} index={0}>
          <Referral episodeHeaderData={episodeParticipant?.data[0]}/>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <ProfA1 episodeHeaderData={episodeParticipant?.data[0]}/>
        </TabPanel>
        <TabPanel value={value} index={2}>
          <ProfA2 episodeHeaderData={episodeParticipant?.data[0]}/>
        </TabPanel>
        <TabPanel value={value} index={3}>
          <ProfB1 episodeHeaderData={episodeParticipant?.data[0]}/>
        </TabPanel>
        <TabPanel value={value} index={4}>
          <ProfB2 episodeHeaderData={episodeParticipant?.data[0]}/>
        </TabPanel>
        <TabPanel value={value} index={5}>
          <AuthTab episodeHeaderData={episodeParticipant?.data[0]}/>
        </TabPanel>
        <TabPanel value={value} index={6}>
          <Activities episodeHeaderData={episodeParticipant?.data[0]}/>
        </TabPanel>
        <TabPanel value={value} index={7}>
          <QualityAssurance episodeHeaderData={episodeParticipant?.data[0]}/>
        </TabPanel>
        <TabPanel value={value} index={8}>
          <AorCm episodeHeaderData={episodeParticipant?.data[0]}/>
        </TabPanel>
        <TabPanel value={value} index={9}>
          <StsAlert episodeHeaderData={episodeParticipant?.data[0]}/>
        </TabPanel>
        <TabPanel value={value} index={10}>
          <TwoTwoEightFour episodeHeaderData={episodeParticipant?.data[0]}/>
        </TabPanel>
        <TabPanel value={value} index={11}>
          <Transport episodeHeaderData={episodeParticipant?.data[0]}/>
        </TabPanel>
        <TabPanel value={value} index={12}>
          <Cmp episodeHeaderData={episodeParticipant?.data[0]}/>
        </TabPanel>
        <TabPanel value={value} index={13}>
          <Oras episodeHeaderData={episodeParticipant?.data[0]}/>
        </TabPanel>
        {/*<TabPanel value={value} index={14}>
          <TP1502 episodeHeaderData={episodeParticipant?.data[0]}/>
        </TabPanel>*/}
        {episodeAuditData && (
          <EpisodeAuditPanel
            episodeCreatedby={episodeAuditData.episodeCreatedby}
            episodedDateCreate={episodeAuditData.episodedDateCreate}
            episodeEditedby={episodeAuditData.episodeEditedby}
            episodedDateEdit={episodeAuditData.episodedDateEdit}
          />
        )}
      </Box>
    </>
  );
};

export default EpisodeDetail;
